// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
let Stdlib_JsError = require("@rescript/runtime/lib/js/Stdlib_JsError.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Types__Attachment = require("../../../reason/common/types/Types__Attachment.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ConversationMessageInputForm = require("../ConversationMessageInputForm.bs.js");
let UnsupportedAttachmentsDialog = require("../../../reason/common/Attachments/UnsupportedAttachmentsDialog.bs.js");
let Conversation__ConversationsSection__Common = require("./Conversation__ConversationsSection__Common.bs.js");
let Conversation__ConversationsSection__SendMessageButtons = require("./Conversation__ConversationsSection__SendMessageButtons.bs.js");
let Conversation__ConversationsSection__ConversationMessageArea = require("./Conversation__ConversationsSection__ConversationMessageArea.bs.js");
let ConversationConversationsSectionStartFirstConversation_context_graphql = require("../../../__generated__/ConversationConversationsSectionStartFirstConversation_context_graphql.bs.js");

let convertFragment = ConversationConversationsSectionStartFirstConversation_context_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__ConversationsSection__StartFirstConversation(props) {
  let onConversationInitiated = props.onConversationInitiated;
  let onStartedInitiatingConversation = props.onStartedInitiatingConversation;
  let context = RescriptRelay_Fragment.useFragment(ConversationConversationsSectionStartFirstConversation_context_graphql.node, convertFragment, props.context);
  let connections = Stdlib_Array.keepSome([props.connectionId]);
  let onConversationInitiated$1 = newConversationId => {
    if (onConversationInitiated !== undefined) {
      return onConversationInitiated(newConversationId);
    }
  };
  let onStartedInitiatingConversation$1 = () => {
    if (onStartedInitiatingConversation !== undefined) {
      return onStartedInitiatingConversation();
    }
  };
  let match = React.useState(() => []);
  let setUnsupportedFiles = match[1];
  let messageConversationType = React.useRef("PRIVATE");
  let agentName;
  switch (context.__typename) {
    case "ForSalePropertyV5" :
      let match$1 = context.agentV2;
      agentName = match$1.__typename === "VisibleForSalePropertyAgent" ? match$1.agent.displayName : undefined;
      break;
    case "__unselected" :
      agentName = UnselectedUnionMemberError.raise(`Can't get agent name for context of type ` + context._0);
      break;
    default:
      agentName = context.agent.displayName;
  }
  let match$2 = Conversation__ConversationsSection__Common.InitiatePropertyConversationMutation.use();
  let initiatePropertyConversationMutate = match$2[0];
  let match$3 = Conversation__ConversationsSection__Common.InitiateMessageBroadcastConversationMutation.use();
  let initiateMessageBroadcastConversation = match$3[0];
  let match$4 = Conversation__ConversationsSection__Common.InitiateRentalNeedConversationMutation.use();
  let initiateRentalNeedConversationMutate = match$4[0];
  let match$5 = Conversation__ConversationsSection__Common.InitiateBuyerNeedConversationMutation.use();
  let initiateBuyerNeedConversationMutate = match$5[0];
  let mutate = (state, reset, notifyOnFailure, notifyOnSuccess) => {
    let match = Belt_Array.partition(state.attachments, Types__Attachment.isImage);
    let files = match[1];
    let images = match[0];
    switch (context.__typename) {
      case "BuyerNeedV5" :
        onStartedInitiatingConversation$1();
        initiateBuyerNeedConversationMutate({
          connections: connections,
          input: {
            buyerNeedId: context.id,
            files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
            images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
            text: state.text
          }
        }, undefined, undefined, undefined, (response, errors) => {
          let match = response.initiateBuyerNeedConversation;
          if (match === undefined) {
            return notifyOnFailure();
          }
          if (match.__typename !== "BuyerNeedConversationInitiated") {
            return notifyOnFailure();
          }
          let match$1 = match.conversation;
          if (match$1 !== undefined) {
            reset();
            notifyOnSuccess(undefined);
            return onConversationInitiated$1(match$1.id);
          } else {
            return notifyOnFailure();
          }
        }, undefined, undefined);
        return;
      case "MessageBroadcast" :
        onStartedInitiatingConversation$1();
        initiateMessageBroadcastConversation({
          connections: connections,
          input: {
            files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
            images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
            messageId: context.id,
            text: state.text,
            visibility: messageConversationType.current
          }
        }, undefined, undefined, undefined, (response, errors) => {
          let match = response.initiateMessageBroadcastConversation;
          if (match === undefined) {
            return notifyOnFailure();
          }
          if (match.__typename !== "MessageBroadcastConversationInitiated") {
            return notifyOnFailure();
          }
          let match$1 = match.conversation;
          if (match$1 !== undefined) {
            reset();
            notifyOnSuccess(undefined);
            return onConversationInitiated$1(match$1.id);
          } else {
            return notifyOnFailure();
          }
        }, undefined, undefined);
        return;
      case "RentalNeedV5" :
        onStartedInitiatingConversation$1();
        initiateRentalNeedConversationMutate({
          connections: connections,
          input: {
            files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
            images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
            rentalNeedId: context.id,
            text: state.text
          }
        }, undefined, undefined, undefined, (response, errors) => {
          let match = response.initiateRentalNeedConversation;
          if (match === undefined) {
            return notifyOnFailure();
          }
          if (match.__typename !== "RentalNeedConversationInitiated") {
            return notifyOnFailure();
          }
          let match$1 = match.conversation;
          if (match$1 !== undefined) {
            reset();
            notifyOnSuccess(undefined);
            return onConversationInitiated$1(match$1.id);
          } else {
            return notifyOnFailure();
          }
        }, undefined, undefined);
        return;
      case "ForSalePropertyV5" :
      case "RentalPropertyV5" :
        break;
      case "__unselected" :
        return Stdlib_JsError.throwWithMessage(`Can't initiate a conversation on context of type ` + context._0);
    }
    onStartedInitiatingConversation$1();
    initiatePropertyConversationMutate({
      connections: connections,
      input: {
        files: files.map(Conversation__ConversationsSection__Common.attachmentToInput),
        images: images.map(Conversation__ConversationsSection__Common.attachmentToInput),
        propertyId: context.id,
        text: state.text
      }
    }, undefined, undefined, undefined, (response, errors) => {
      let match = response.initiatePropertyConversation;
      if (match === undefined) {
        return notifyOnFailure();
      }
      if (match.__typename !== "PropertyConversationInitiated") {
        return notifyOnFailure();
      }
      let match$1 = match.conversation;
      if (match$1 !== undefined) {
        reset();
        notifyOnSuccess(undefined);
        return onConversationInitiated$1(match$1.id);
      } else {
        return notifyOnFailure();
      }
    }, undefined, undefined);
  };
  let match$6 = ConversationMessageInputForm.useWithAttachments(mutate, files => setUnsupportedFiles(param => files));
  let form = match$6[0];
  let submitDisabled = form.submitting || !form.valid();
  let tmp;
  switch (context.__typename) {
    case "MessageBroadcast" :
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPrivateMessageButton.make, {
            submitDisabled: submitDisabled,
            onSubmit: () => {
              messageConversationType.current = "PRIVATE";
              form.submit();
            }
          }),
          JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPublicMessageButton.make, {
            submitDisabled: submitDisabled,
            onSubmit: () => {
              messageConversationType.current = "PUBLIC";
              form.submit();
            }
          })
        ]
      });
      break;
    case "__unselected" :
      tmp = null;
      break;
    default:
      tmp = JsxRuntime.jsx(Conversation__ConversationsSection__SendMessageButtons.SendPrivateMessageButton.make, {
        submitDisabled: submitDisabled,
        onSubmit: () => form.submit()
      });
  }
  let match$7 = form.status;
  let tmp$1;
  tmp$1 = typeof match$7 !== "object" || match$7.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(ErrorComponent.make, {
      message: "An error ocurred while sending the message"
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(UnsupportedAttachmentsDialog.make, {
        files: match[0],
        onDismiss: () => setUnsupportedFiles(param => [])
      }),
      JsxRuntime.jsx("form", {
        children: JsxRuntime.jsxs(ViewStack.make, {
          alignItems: "flexEnd",
          flexDirection: "column",
          children: [
            JsxRuntime.jsx(Conversation__ConversationsSection__ConversationMessageArea.make, {
              form: form,
              attachmentsManager: match$6[1],
              inputRef: props.inputRef,
              submitButtons: tmp,
              placeholder: agentName !== undefined ? `Message to ` + agentName : ""
            }),
            tmp$1
          ]
        }),
        className: "w-full"
      })
    ]
  });
}

let Commons;

let ConversationMessageForm;

let ConversationMessageArea;

let SendMessageButtons;

let make = Conversation__ConversationsSection__StartFirstConversation;

exports.Fragment = Fragment;
exports.Commons = Commons;
exports.ConversationMessageForm = ConversationMessageForm;
exports.ConversationMessageArea = ConversationMessageArea;
exports.SendMessageButtons = SendMessageButtons;
exports.make = make;
/* react Not a pure module */
